var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentConfirmImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225.188,
    height: 217.988,
    viewBox: "0 0 225.188 217.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 225.188,
    height: 217.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 14.48,
    height: 18.903,
    transform: "translate(55.49 198.181)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 14.477,
    height: 18.903,
    transform: "translate(55.491 198.181)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 28.368,
    height: 24.124,
    transform: "translate(35.345 74.234)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 44.388,
    height: 25.644,
    transform: "translate(133.955 113.525)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 6.9,
    height: 6.434,
    transform: "translate(194.774 72.318)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 6.897,
    height: 6.431,
    transform: "translate(194.777 72.32)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 13.005,
    height: 19.201,
    transform: "translate(207.859 89.959)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.221,177.349l1.884-.248-1.737,1.049a19.745,19.745,0,0,0,4.174,8.5l.012.012c.7.767,3.362-1.015,3.858-1.467,1.952-1.749,2.854-4.31,3.7-6.713,1.038-2.934,2.019-5.889,3.26-8.744.993-2.279,2.1-4.513,3.182-6.747l-.937-2.775,2.347-.237c.225-.5.44-.993.654-1.489.959-2.233,1.873-4.478,2.719-6.758-.417.147-11.372,4.265-18.006,11.124l.869,1.4-2.527.5a17.379,17.379,0,0,0-2.1,3.328,15.523,15.523,0,0,0-1.354,9.274",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.273,171.032c.225.271.429.553.643.835a74.969,74.969,0,0,0,6.7,8.146l1.2-.79s-.406.8-.654,1.343A79.677,79.677,0,0,0,53.88,186.8a9.449,9.449,0,0,0,2.2,1.433l.981-1.049s-.023.756-.023,1.354a3.252,3.252,0,0,0,1.1.034c.5-.068,2.279-.417,2.527-.9l.011-.011A9.551,9.551,0,0,0,58.5,177.518a9.725,9.725,0,0,0-1.568-1.309l-.767.993-1.286-2.166a31.455,31.455,0,0,0-3.731-1.43,59.924,59.924,0,0,0-8.428-2.042c-1.139-.2-2.29-.372-3.441-.541",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.555,191.328l.011.011c3.1,1.332,6.736.147,10.019-1.816-.429-.891-1.3-2.651-1.376-2.764s1.6,1.23,2.572,2.008a46.883,46.883,0,0,0,8.439-7.48s-12.422-.79-17.036,1.6a6.241,6.241,0,0,0-1.185.8l.406.948-1.038-.271c-2.189,2.786-.812,6.961-.812,6.961",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.87,200.417s-4.3-26.729,11.362-41.793",
    fill: "none",
    stroke: "#232a3a",
    strokeWidth: 1.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.274,204.219s-1.52-20.975-19.1-28.076",
    fill: "none",
    stroke: "#232a3a",
    strokeWidth: 1.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.117,198.967s7-13.264,17.719-15.71",
    fill: "none",
    stroke: "#232a3a",
    strokeWidth: 1.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.453,198.058l5.272,19.026H71.737l5.234-18.9a.25.25,0,0,0,.019-.066l.019-.058Z",
    fill: "#232a3a"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.97,217.084H60.724l-5.234-18.9c.506,1.566,5.96,17.842,14.479,18.9",
    fill: "#6579b9"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M121.987,136.234l-1.464,32.352-34.216-1.549L88.24,124.33l23.863,1.08Z",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.633,135.764l10.355.469L112.1,125.412Z",
    fill: "#c4c6e5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.109,
    height: 22.656,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 92.903, 147.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.109,
    height: 22.656,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 93.174, 141.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.109,
    height: 22.656,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 92.632, 153.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.109,
    height: 22.656,
    transform: "translate(92.362 159.526) rotate(-87.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.865,25.534l-.609,13.458-14.233-.644.8-17.765,9.926.45Z",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.557,25.343l4.307.2-4.112-4.5Z",
    fill: "#c4c6e5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.877,
    height: 9.426,
    transform: "matrix(0.046, -0.999, 0.999, 0.046, 68.766, 30.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.877,
    height: 9.426,
    transform: "matrix(0.046, -0.999, 0.999, 0.046, 68.879, 27.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.877,
    height: 9.426,
    transform: "matrix(0.046, -0.999, 0.999, 0.046, 68.654, 32.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.877,
    height: 9.426,
    transform: "matrix(0.046, -0.999, 0.999, 0.046, 68.541, 35.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.727,77.15,76.533,145.822a3.173,3.173,0,0,1-3.817,2.36L3,131.742a3.172,3.172,0,0,1-2.36-3.815L21.521,39.373a3.174,3.174,0,0,1,3.817-2.361L75.18,48.766Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.727,77.15,76.533,145.822a3.173,3.173,0,0,1-3.817,2.36L3,131.742a3.172,3.172,0,0,1-2.36-3.815L21.521,39.373a3.174,3.174,0,0,1,3.817-2.361L75.18,48.766Z",
    fill: "none",
    stroke: "#dfe8f7",
    strokeWidth: 1.107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.757,71.731l22.969,5.416L75.172,48.767Z",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.857,
    height: 51.569,
    transform: "translate(20.594 99.926) rotate(-76.706)",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.857,
    height: 51.569,
    transform: "translate(18.101 110.5) rotate(-76.706)",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.857,
    height: 51.569,
    transform: "translate(15.607 121.074) rotate(-76.706)",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.913,98.668,25.842,87.8a2.122,2.122,0,0,1-1.578-2.552l3.5-14.822a2.122,2.122,0,0,1,2.552-1.578L76.38,79.715a2.123,2.123,0,0,1,1.578,2.552l-3.5,14.822a2.122,2.122,0,0,1-2.552,1.578",
    fill: "#c04f49"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.445,82.11a2.677,2.677,0,0,1-1.332.771,3.911,3.911,0,0,1-1.914-.037l-1.341-.316L40.1,85.715,37.941,85.2l2.1-8.88,3.5.828a4.1,4.1,0,0,1,1.709.791,2.6,2.6,0,0,1,.862,1.273,3.018,3.018,0,0,1,.017,1.567,2.966,2.966,0,0,1-.687,1.328m-2.013-1.1a1.3,1.3,0,0,0,.39-1.645,1.328,1.328,0,0,0-.855-.509L41.79,78.58l-.526,2.227,1.177.279a1.321,1.321,0,0,0,.991-.074",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.583,80.112a4.1,4.1,0,0,1,1.256,1.947,5.094,5.094,0,0,1-1.1,4.637,4.074,4.074,0,0,1-2,1.182,5.319,5.319,0,0,1-2.58-.022l-3.326-.787,2.1-8.879,3.327.785a5.351,5.351,0,0,1,2.322,1.137m-2.05,5.621A2.619,2.619,0,0,0,52.665,84a2.434,2.434,0,0,0-1.981-3.2l-1.024-.243L48.44,85.71l1.026.242a2.687,2.687,0,0,0,2.067-.219",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.911,81.729l-.41,1.734-3.618-.855-.443,1.873,2.707.639-.4,1.681-2.707-.638-.85,3.591-2.163-.511,2.1-8.879Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.149,62.031l11.588,68.783a3.137,3.137,0,0,1-2.572,3.615l-69.833,11.764a3.138,3.138,0,0,1-3.615-2.572l-14.945-88.7a3.138,3.138,0,0,1,2.573-3.615L156.27,42.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.149,62.031l11.588,68.783a3.137,3.137,0,0,1-2.572,3.615l-69.833,11.764a3.138,3.138,0,0,1-3.615-2.572l-14.945-88.7a3.138,3.138,0,0,1,2.573-3.615L156.27,42.9Z",
    fill: "none",
    stroke: "#dfe8f7",
    strokeWidth: 1.107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.143,65.9l23.007-3.876L156.268,42.9Z",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.988,
    height: 3.814,
    transform: "translate(120.494 76.825) rotate(-9.557)",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.988,
    height: 3.814,
    transform: "translate(122.867 90.916) rotate(-9.557)",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.994,
    height: 3.814,
    transform: "translate(125.241 105.006) rotate(-9.562)",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,129.027l-46.148,7.779a2.1,2.1,0,0,1-2.418-1.72l-2.5-14.847a2.1,2.1,0,0,1,1.72-2.418l46.148-7.774a2.1,2.1,0,0,1,2.418,1.721l2.5,14.847a2.1,2.1,0,0,1-1.72,2.417",
    fill: "#a6a9d5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M147.458,120.182l-.83,9.394-2.652.447-2.434-5.681-.49,6.173-2.653.446-3.8-8.613,2.345-.4,2.4,6.332.5-6.82,2.408-.4,2.642,6.29.206-6.771Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.923,128.171a4.476,4.476,0,0,1-1.957-1.366,4.907,4.907,0,0,1-.8-4.75,4.5,4.5,0,0,1,1.4-1.924,4.958,4.958,0,0,1,4.654-.783,4.425,4.425,0,0,1,1.944,1.36,4.984,4.984,0,0,1,.793,4.752,4.426,4.426,0,0,1-1.389,1.927,4.948,4.948,0,0,1-4.646.784m3.691-2.811a3.155,3.155,0,0,0-.641-3.8,2.245,2.245,0,0,0-1.843-.422,2.274,2.274,0,0,0-1.618,1,3.176,3.176,0,0,0,.643,3.815,2.488,2.488,0,0,0,3.459-.59",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.74,126.524l-2.442-3.082-.526.089.572,3.4-2.19.369-1.517-9,3.678-.621a4.127,4.127,0,0,1,1.878.067,2.6,2.6,0,0,1,1.293.83,2.9,2.9,0,0,1,.614,1.38,2.733,2.733,0,0,1-.235,1.688,2.764,2.764,0,0,1-1.328,1.25l2.678,3.215Zm-3.23-4.544,1.359-.229a1.247,1.247,0,0,0,.854-.448,1.12,1.12,0,0,0,.162-.884,1.105,1.105,0,0,0-.438-.756,1.262,1.262,0,0,0-.953-.143l-1.359.229Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.948,116.467a4.074,4.074,0,0,1,1.914,1.307,5.092,5.092,0,0,1,.791,4.7,4.047,4.047,0,0,1-1.385,1.868,5.314,5.314,0,0,1-2.386.983l-3.371.567-1.516-9,3.371-.568a5.325,5.325,0,0,1,2.582.144m.295,5.975a2.6,2.6,0,0,0,.367-2.039,2.437,2.437,0,0,0-3.07-2.185l-1.037.175.881,5.231,1.037-.176a2.679,2.679,0,0,0,1.822-1.006",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.172,98.395A18.153,18.153,0,1,1,99.019,80.242a18.153,18.153,0,0,1,18.153,18.153",
    fill: "#c04f49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.718,
    height: 3.658,
    transform: "translate(88.188 91.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,93.315l-5.7-4.46v8.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.718,
    height: 3.658,
    transform: "translate(92.131 101.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.188,103.473l5.7-4.46v8.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.716,159.445c9.071-4.966,4.664,37.4,1.552,48.01s-4.165-.88-4.579-18.332-.543-27.724,3.026-29.677",
    fill: "#e2b28e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.757,210.164l-.139-4.279,6.409.071.129,4.189",
    fill: "#e2b28e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.844,158.369c9.8-3.3,1.386,43.2-3.537,53.1s-3.946-1.6-1.3-18.851.978-32.952,4.834-34.251",
    fill: "#e2b28e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.038,151.68l-4.569,56.92,6.2.174s7.243-29.522,7.33-45.064l4.671-16.745Z",
    fill: "#e2b28e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.493,118.86s-7.065,61.128-7.67,85.965l9.3.618L199.08,140.57l3.6,66.393,8.377.032s6.981-79.08,3.425-87.964Z",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.469,208.6a30.579,30.579,0,0,1-6.286,4.726c-4.376,2.642-5.471,1.988-5.608,3.033s18.191.88,18.191.88l-.043-8.639s-6.242-.224-6.253,0",
    fill: "#232a3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.757,210.163c-.053,1.377-1.562,6.536-1.574,7.73,9.973.022,9.77,1.468,7.974-7.748Z",
    fill: "#232a3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.894,79.435c-5.468-1.6-24.158,22.206-20.584,24.006,3.878,5.214,28.843-19.665,20.584-24.006",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.952,76.737l8.1,18.081,2.1-2.373,5.459,8.465s-6.606,6.13-10.759,4.114-8.942-27.181-8.942-27.181Z",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.045,81.119s-2.249,2.344-10,11.758l6.408,8.464L191,95.8Z",
    fill: "#c04f49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.745,104.231a2.63,2.63,0,0,1-2.4-.94c-4.621-5.419-9.781-30.768-7.753-30.365,1.436-.307,16.9,30.143,10.154,31.305",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.025,70.383l.062.973c.279,1.308.253,2.377,1.028,3.479l.321.353,2.5,2.731,4.044-1.106.285-1.366v-.014l.39-2.391a3.825,3.825,0,0,0-.16-1.817l-1.5-2.3s-.819-.182-.333,1.3a3,3,0,0,1-.176,1.526l-.3-.618-.374-.768-1.6-3.083c-.486-.837-4.417,1.291-4.194,3.107",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,80.686l-4.687,3.475-3.31-2.986.025-4.475,6.683-5.18.113.8.334,2.381Z",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.674,73.14c-1.843,3.609-6.07,5.364-6.9,5.612v-.938l6.234-5.463a5.137,5.137,0,0,1,.568-.032Z",
    fill: "#d18d8c"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M202.038,72.463a9.393,9.393,0,0,1-4.128,4.124c-1.35.649-2.88,1.529-4.434,1.215-1.372-.277-2.089-1.648-2.669-2.784a7.83,7.83,0,0,1-.817-3.591,18.209,18.209,0,0,0-.2-3.951c-.222-1.04-.548-2.342.08-3.309.813-1.252,7.1-2.78,7.1-2.78l3.686,2.06,2.786,1.865Z",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.171,69.444c0,.386.207.7.455.7s.447-.317.443-.7a.927.927,0,0,0-.136-.494.388.388,0,0,0-.319-.2c-.248,0-.447.317-.443.7",
    fill: "#232a3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.544,69.7c0,.386.23.7.5.7s.5-.317.494-.7a.854.854,0,0,0-.151-.494.444.444,0,0,0-.355-.2c-.276,0-.5.318-.494.7",
    fill: "#232a3a"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.637,
    y2: 0.181,
    transform: "translate(195.017 67.607)",
    fill: "none",
    stroke: "#232a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.454
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.306,
    y2: 0.022,
    transform: "translate(190.822 67.523)",
    fill: "none",
    stroke: "#232a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.454
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.656,69.828s-.51.91-.7,1.155-.751,1.043.512,1.085",
    fill: "none",
    stroke: "#232a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.454
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.231,73.381a2.991,2.991,0,0,1-.364.3,2.845,2.845,0,0,1-1.5.57c-.449.02-.886-.43-1.1-.693-.09-.111-.143-.188-.143-.188s.289.02.7.04c.447.02,1.039.038,1.557.03a6.5,6.5,0,0,0,.859-.06",
    fill: "#232a3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.231,73.381a2.991,2.991,0,0,1-.364.3,5.412,5.412,0,0,1-2.609-.123c-.09-.111-.143-.188-.143-.188s.289.02.7.04c.447.02,1.039.038,1.557.03a6.5,6.5,0,0,0,.859-.06",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.652,65.1a2.076,2.076,0,0,0,1.214,1.42,5.072,5.072,0,0,1-3.115-.641s.55.847,1.008.985c0,0-2.428.115-3.207-.779l.275,1.535a5,5,0,0,1-1.4-3.138,11.836,11.836,0,0,1,.938-3.474,3.263,3.263,0,0,1,1.335-1.977,8.965,8.965,0,0,1,6.38-.331,11.735,11.735,0,0,1,4.668,2.1c3.515,2.925,2.157,9.388-.2,12.625,0,0-.291-2.963-.337-3.879s-.87-1.145-.848-.71-.048,2.574-.505,2.551-.636-3.764-1.736-4.543-3.577-1.009-4.47-1.742",
    fill: "#232a3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.557,127.052l-30.247.395c.452-6.32-1.225-27.016-1.433-32.661v-.013c-.006-.2-.014-.4-.019-.593-.151-4.56-.123-8.277.264-9.659a6.8,6.8,0,0,1,3.192-4.382,15.87,15.87,0,0,1,6.758-1.745c.876,4.949,7.711.142,7.711.142s1.632.17,2.808.252c2.758.186,7.5,1.112,8.426,5.206.449,1.979.962,7.144,1.508,12.982.306,3.3.62,6.814.936,10.1.19,1.965-.091,18.275.1,19.975",
    fill: "#c04f49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.772,77.908l1.357,2.48-1.449,1.126-1.1-3.059",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.129,80.389,202.3,77.2l1.221,1.534-6.5,3.42Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.859,89.959s4.192,11.953,4.664,13.4.2,2.613-1.939,3.507,3.344,2.578,3.452,2.259,7.234-6.463,6.81-6.838S207.86,89.963,207.86,89.963",
    fill: "#b6c7e1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.8,82.11c-3.82,4.228,9.943,31.891,13.117,29.454C229.3,110.337,217.3,76.558,209.8,82.11",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.151,96.266s4.518,11.541,2.532,14.089-20.91,3.9-20.91,3.9l-.78-5.2s13.159-3.15,13.2-3.35-3.165-5.9-3.165-5.9Z",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,109.056a2.63,2.63,0,0,1-1.376,2.181c-6.193,3.517-33.509,3.809-32.731,1.893-.032-1.468,34.238-10.923,34.107-4.074",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3,109.993l21.253-4.456-2.364-5.483,9.17-3.64L224.2,108.94l-13.141,4.916-17.485.267V109.98Z",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.092,114.449l.907.359c1.3.305,2.258.785,3.585.553l.456-.14,3.536-1.1.2-3.816.522-.313-1.114-.84-.012-.007-2-1.372a3.821,3.821,0,0,0-1.711-.63l-2.721.371s-.514.664,1.031.854a2.985,2.985,0,0,1,1.306.809l-.687.006-.854.011-3.471.133c-.964.083-.715,4.547,1.023,5.119",
    fill: "#d18d8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.826,100.531v-.006c-1.922-3.551-4.337-8.255-4.97-10.564,0,0-4.214-8.792-1.034-10.219a3.718,3.718,0,0,1,1.758-.386,15.939,15.939,0,0,1,8.878,6.485,58.966,58.966,0,0,1,5.174,10.469.025.025,0,0,1,0,.012Z",
    fill: "#c04f49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.518,17.059h-2.307A17.265,17.265,0,0,0,134.2,12.03l1.7-1.7a1.538,1.538,0,0,0,0-2.174l-3.718-3.72a1.538,1.538,0,0,0-2.174,0L128.366,6.07a17.447,17.447,0,0,0-4.986-2.134v-2.4A1.538,1.538,0,0,0,121.847,0h-5.261a1.537,1.537,0,0,0-1.537,1.537v2.31a17.408,17.408,0,0,0-5.03,2.012l-1.7-1.7a1.538,1.538,0,0,0-2.174,0l-3.72,3.72a1.538,1.538,0,0,0,0,2.174l1.635,1.635a17.266,17.266,0,0,0-2.134,4.978h-2.4A1.537,1.537,0,0,0,97.989,18.2v5.26A1.537,1.537,0,0,0,99.523,25h2.318a17.11,17.11,0,0,0,2.011,5.028l-1.7,1.7a1.538,1.538,0,0,0,0,2.174l3.719,3.719a1.538,1.538,0,0,0,2.174,0L109.68,36a17.456,17.456,0,0,0,4.978,2.134v2.4a1.54,1.54,0,0,0,1.538,1.538h5.26a1.538,1.538,0,0,0,1.537-1.538v-2.31a17.182,17.182,0,0,0,5.024-2.012l1.7,1.7a1.538,1.538,0,0,0,2.174,0l3.72-3.719a1.538,1.538,0,0,0,0-2.174l-1.631-1.635a17.256,17.256,0,0,0,2.14-4.978h2.394a1.538,1.538,0,0,0,1.537-1.537V18.6a1.537,1.537,0,0,0-1.537-1.537m-19.5,13.761a9.788,9.788,0,1,1,9.793-9.787,9.788,9.788,0,0,1-9.793,9.787h0",
    fill: "#dfe8f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.419,
    cy: 2.419,
    r: 2.419,
    transform: "translate(151.676 20.773)",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.18,160.1a2.419,2.419,0,1,1-2.419-2.419A2.419,2.419,0,0,1,47.18,160.1",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.361,159.264a2.419,2.419,0,1,1-2.419,2.419,2.419,2.419,0,0,1,2.419-2.419",
    fill: "#a6a9d5"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.004,
    transform: "translate(178.347 37.403)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 2.955
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.004,
    transform: "translate(178.347 29.788)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 2.955
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.004,
    transform: "translate(172.534 35.602)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 2.955
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.013,
    transform: "translate(180.148 35.602)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 2.955
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.624,
    transform: "translate(124.535 174.216)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.624,
    transform: "translate(124.535 169.225)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.624,
    transform: "translate(120.725 173.035)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.63,
    transform: "translate(125.715 173.035)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.624,
    transform: "translate(47.456 25.505)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.624,
    transform: "translate(47.456 20.515)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.624,
    transform: "translate(43.646 24.325)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.63,
    transform: "translate(48.636 24.325)",
    fill: "none",
    stroke: "#3a4693",
    strokeWidth: 1.937
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentConfirmImage);
export default __webpack_public_path__ + "static/media/document-confirm-image.c60f8957fc8218d932d3e55ce6cfee5a.svg";
export { ForwardRef as ReactComponent };